function initToolsProduct(root) {
  if (root.dataset.toolsReady) return;
  root.dataset.toolsReady = 'true';
  const money = (cents) => window.PDCart?.money?.(cents) || `${(Number(cents || 0) / 100).toFixed(2)}`;
  const thumbs = [...root.querySelectorAll('[data-tools-thumb]')];
  const media = [...root.querySelectorAll('[data-tools-media]')];
  const showMedia = (mediaId) => {
    thumbs.forEach((thumb) => thumb.dataset.mediaId === String(mediaId) ? thumb.setAttribute('aria-current', 'true') : thumb.removeAttribute('aria-current'));
    media.forEach((panel) => { panel.hidden = panel.dataset.toolsMedia !== String(mediaId); });
  };
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaId)));

  const quantity = root.querySelector('input[name="quantity"]');
  root.querySelectorAll('[data-tools-quantity]').forEach((button) => button.addEventListener('click', () => {
    const current = Math.max(1, Number.parseInt(quantity?.value || '1', 10));
    if (quantity) quantity.value = button.dataset.toolsQuantity === 'increase' ? current + 1 : Math.max(1, current - 1);
  }));
  quantity?.addEventListener('change', () => { quantity.value = String(Math.max(1, Number.parseInt(quantity.value || '1', 10))); });

  const variant = root.querySelector('[data-tools-variant]');
  const price = root.querySelector('[data-tools-price]');
  const compare = root.querySelector('[data-tools-compare]');
  const sale = root.querySelector('[data-tools-sale]');
  const add = root.querySelector('[data-tools-add]');
  const addLabel = root.querySelector('[data-tools-add-label]');
  const updateVariant = () => {
    const option = variant?.selectedOptions?.[0];
    if (!option) return;
    const variantPrice = Number(option.dataset.price || 0);
    const comparePrice = Number(option.dataset.compare || 0);
    const available = option.dataset.available === 'true';
    const onSale = comparePrice > variantPrice;
    if (price) price.textContent = money(variantPrice);
    if (compare) { compare.textContent = onSale ? money(comparePrice) : ''; compare.hidden = !onSale; }
    if (sale) sale.hidden = !onSale;
    if (add) add.disabled = !available;
    if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Sold out';
    if (option.dataset.mediaId) showMedia(option.dataset.mediaId);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  };
  variant?.addEventListener('change', updateVariant);

  const form = root.querySelector('form[data-ajax-product-form]');
  form?.addEventListener('submit', async (event) => {
    if (!window.fetch || !window.PDCart?.refresh || add?.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    if (quantity) quantity.value = String(Math.max(1, Number.parseInt(quantity.value || '1', 10)));
    const status = root.querySelector('[data-product-status]');
    add?.setAttribute('aria-busy', 'true');
    if (add) add.disabled = true;
    if (addLabel) addLabel.textContent = 'Adding…';
    if (status) status.textContent = '';
    try {
      const response = await fetch(window.PDTheme.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add this item.');
      await window.PDCart.refresh(true);
      if (status) status.textContent = 'Added to your cart.';
    } catch (error) {
      if (status) status.textContent = error.message;
    } finally {
      add?.removeAttribute('aria-busy');
      const selected = variant?.selectedOptions?.[0];
      const available = selected ? selected.dataset.available === 'true' : true;
      if (add) add.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Sold out';
    }
  });
}
document.querySelectorAll('[data-tools-product]').forEach(initToolsProduct);
document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-tools-product]').forEach(initToolsProduct));
